import React from "react"
import { MarketStatCollection, MarketStatsWithSliderBlade } from "@organic-return/foundation-react/src/components/Blades/MarketStatsWithSliderBlade"
import { graphql, useStaticQuery } from "gatsby"
import { useSiteContext } from "../common/SiteContext"
import { MarketStatsMarket } from "@organic-return/foundation-react/src/components/MarketStats/MarketStats"


export const MarketStatsWithSlider = ({ module }) => {
  const data = useStaticQuery(graphql`
          query {  
            allAgilityMarketStatsWithSlider {
              nodes {
                contentID      
                filterList {
                  customFields {
                    title
                  }
                  listItems {
          			marketStatsJSON
                  }
                }
              }
            }
          }
        `)
  const siteContext = useSiteContext()
  const fields = module.customFields

  const marketsCollection: MarketStatCollection[] = data.allAgilityMarketStatsWithSlider?.nodes?.
    find(item => item.contentID == module.contentID)?.
    filterList?.map((item, index): MarketStatCollection => {
      return {
        label: item?.customFields?.title,
        markets: item?.listItems?.map((x): MarketStatsMarket => {
          return x.marketStatsJSON ? JSON.parse(x.marketStatsJSON).markets?.[0] : null
        }) ?? []
      }
    }) ?? []

  return (
    <MarketStatsWithSliderBlade
      title={fields.title}
      sectionClassNames="market-stats-w-slider inverted"
      marketsCollection={marketsCollection}
      contentColText={fields.contentColumnText}
      contentColCTA={fields.contentColumnCTA}
      statsBgImage={fields.statsBgImage?.url}
      bottomCTADefaultText={fields.bottomCTADefaultText}
      {...siteContext.globalMarketStatsWithSliderProps}
    />
  )
}

export default MarketStatsWithSlider